import script from "./single-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./single-select.vue?vue&type=script&setup=true&lang=ts"

import "./single-select.vue?vue&type=style&index=0&id=c3b777a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b777a2"]])

export default __exports__